export default __webpack_public_path__ + "static/media/vitalik_poap_16.69ba8602.svg";